import { toByte4i43936u611k as toByte } from '../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.byteArrayOf' call
  return new Int8Array([toByte(_this__u8e3s4), toByte(_this__u8e3s4 >> 8), toByte(_this__u8e3s4 >> 16), toByte(_this__u8e3s4 >> 24)]);
}
//region block: exports
export {
  toByteArray as toByteArrayce03j8fj9exs,
};
//endregion

//# sourceMappingURL=Int.ext.mjs.map
